import type { RouteObject } from "react-router"

import { FeatureGuard } from "@/components/route/featureGuard/featureGuard"
import { RootPath, SitePath } from "@/models/route"
import { PAGE_LAYOUT_FILL, PAGE_LAYOUT_SCROLL } from "@/utils/page-layout-mode"

import { SiteBillRoute } from "./pages/site-bill-route"
import { SiteBillsRoute } from "./pages/site-bills-route"
import { SiteDetailsRoute } from "./pages/site-details-route"
import { SiteIndexRoute } from "./pages/site-index-route/site-index-route"
import { SiteIntervalDataRoute } from "./pages/site-interval-data-route"
import { SiteOverviewRoute } from "./pages/site-overview-route/site-overview-route"
import { SitesComplianceRoute } from "./pages/sites-compliance-route/sites-compliance-route"
import { SitesIndexRoute } from "./pages/sites-index-route/sites-index-route"
import { SitesLayoutRoute } from "./pages/sites-layout-route/sites-layout-route"
import { SitesOverviewRoute } from "./pages/sites-overview-route/sites-overview-route"
import { SitesPerformanceRoute } from "./pages/sites-performance-route/sites-performance-route"

export const siteRoutes: RouteObject[] = [
  {
    path: RootPath.Site,
    element: <SitesLayoutRoute />,
    children: [
      {
        path: SitePath.Site,
        element: <SiteIndexRoute />,
        children: [
          {
            path: SitePath.Overview,
            handle: { siteLayout: PAGE_LAYOUT_FILL },
            element: <SiteOverviewRoute />,
          },
          {
            path: SitePath.SiteDetails,
            handle: { siteLayout: PAGE_LAYOUT_FILL },
            element: <SiteDetailsRoute />,
          },
          {
            path: SitePath.Bills,
            handle: { siteLayout: PAGE_LAYOUT_SCROLL },
            element: (
              <FeatureGuard feature="site_bills">
                <SiteBillsRoute />
              </FeatureGuard>
            ),
          },
          {
            path: SitePath.Intervals,
            handle: { siteLayout: PAGE_LAYOUT_SCROLL },
            element: (
              <FeatureGuard feature="site_interval_data">
                <SiteIntervalDataRoute />
              </FeatureGuard>
            ),
          },
          {
            path: `${SitePath.Bills}/${SitePath.Bill}`,
            handle: { siteLayout: PAGE_LAYOUT_SCROLL },
            element: (
              <FeatureGuard feature="site_bills">
                <SiteBillRoute />
              </FeatureGuard>
            ),
          },
        ],
      },
      {
        index: true,
        element: <SitesIndexRoute />,
      },
      {
        element: <SitesIndexRoute />,
        children: [
          {
            path: SitePath.Overview,
            element: <SitesOverviewRoute />,
          },
          {
            path: SitePath.Performance,
            element: <SitesPerformanceRoute />,
          },
          {
            path: SitePath.Compliance,
            element: (
              <FeatureGuard feature="sites_compliance">
                <SitesComplianceRoute />
              </FeatureGuard>
            ),
          },
        ],
      },
    ],
  },
]
